"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactSelect = _interopRequireDefault(require("react-select")),
    _async = _interopRequireDefault(require("react-select/async")),
    _classnames = _interopRequireDefault(require("classnames")),
    _LabelWrapper = _interopRequireDefault(require("../../LabelWrapper")),
    _dropdown = _interopRequireDefault(require("../styles/dropdown")),
    _DropdownLabel = _interopRequireDefault(require("./DropdownLabel")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _dropdownLabel = require("../styles/dropdownLabel"),
    _utils = require("../utils"),
    _DropdownLabelContent = _interopRequireDefault(require("./DropdownLabelContent")),
    _Text = _interopRequireDefault(require("../../Text/Text"));

require("../styles/_dropdown.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Dropdown = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.getOption = function (a) {
      var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          c = b.ignoreButton,
          e = d.props,
          f = e.type,
          g = e.children,
          h = e.placeholder;
      return c || "BUTTON" !== f ? "string" == typeof a ? {
        value: a,
        label: a
      } : a : "string" == typeof g || "number" === g ? {
        value: null,
        label: _react["default"].createElement(_Text["default"], {
          button: !0
        }, g)
      } : {
        value: null,
        label: g ? g : _react["default"].createElement(_Text["default"], {
          button: !0
        }, h)
      };
    }, d.createSingleValue = function (a) {
      var b = a.data,
          c = b.label,
          e = b.prefix,
          f = d.props,
          g = f.hideSelectedLabel,
          h = f.prefixSize,
          i = f.disabled;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("dropdown-option", _dropdownLabel.DROPDOWN_VALUE)
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("dropdown-option__content", _dropdownLabel.DROPDOWN_LABEL)
      }, (0, _utils.getPrefix)({
        prefix: e,
        size: h
      }), !g && _react["default"].createElement(_DropdownLabelContent["default"], {
        label: c,
        disabled: i
      })));
    }, d.isOptionSelected = function (a) {
      var b = d.state.selectedItems;
      return !!(b && Array.isArray(b)) && b.some(function (b) {
        return b.label === a;
      });
    }, d.createDropdownLabel = function (a) {
      var b = d.props,
          c = b.prefixSize,
          e = b.multi,
          f = b.disabled,
          g = a.label;
      return _react["default"].createElement(_DropdownLabel["default"], (0, _extends2["default"])({
        isSelected: d.isOptionSelected(g),
        prefixSize: c,
        disabled: f
      }, a, {
        isMulti: e
      }));
    }, d.createDropdownArrow = function (a) {
      var b = a.selectProps.value,
          c = d.props,
          e = c.disabled,
          f = c.showSelectedSuffix;
      return _react["default"].createElement(_react["default"].Fragment, null, f && _react["default"].createElement("div", {
        className: "dropdown-option__suffix",
        style: {
          color: e ? "#CBD0DB" : void 0
        }
      }, b && b.suffix), _react["default"].createElement(_Icon["default"], {
        size: 8,
        className: "dropdown__icon",
        color: e ? "michael" : void 0,
        name: "arrowdown"
      }));
    }, d.onSelectionChange = function (a) {
      var b = d.props.onChange;
      d.setState({
        selectedItems: a
      }), b && b(a);
    }, d.state = {
      selectedItems: ""
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "getOptions",
    value: function getOptions(a) {
      var b = this;
      return a ? a.map(function (a) {
        return b.getOption(a, {
          ignoreButton: !0
        });
      }).filter(Boolean) : [];
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.onChange,
          c = a.placeholder,
          d = void 0 === c ? "Select" : c,
          e = a.id,
          f = a.label,
          g = a.disabled,
          h = a.defaultValue,
          i = a.value,
          j = a.multi,
          k = a.classNamePrefix,
          l = a.className,
          m = a.renderMenuLocally,
          n = a.options,
          o = a.isSearchable,
          p = a.searchPromptText,
          q = a.noResultsText,
          r = a.isClearable,
          s = a.loadOptions,
          t = a.type,
          u = a.labelProps,
          v = a.menuWidth,
          w = a.children,
          x = a.fixedButtonValue,
          y = (0, _objectWithoutProperties2["default"])(a, ["onChange", "placeholder", "id", "label", "disabled", "defaultValue", "value", "multi", "classNamePrefix", "className", "renderMenuLocally", "options", "isSearchable", "searchPromptText", "noResultsText", "isClearable", "loadOptions", "type", "labelProps", "menuWidth", "children", "fixedButtonValue"]),
          z = s ? _async["default"] : _reactSelect["default"];
      return _react["default"].createElement(_LabelWrapper["default"], (0, _extends2["default"])({}, u, {
        className: "dropdown__label-wrapper",
        id: e,
        label: f,
        disabled: g
      }), _react["default"].createElement(z, (0, _extends2["default"])({
        id: f ? void 0 : e,
        className: (0, _classnames["default"])("dropdown", {
          "dropdown--btn": "BUTTON" === t
        }, l),
        classNamePrefix: "react-select",
        styles: (0, _dropdown["default"])({
          disabled: g,
          menuWidth: v
        }),
        placeholder: d,
        isDisabled: g,
        options: this.getOptions(n),
        defaultValue: this.getOption(h, {
          ignoreButton: !0
        }),
        value: i ? this.getOption(i, {
          ignoreButton: !x
        }) : i,
        isMulti: j,
        onChange: this.onSelectionChange,
        hideSelectedOptions: !1,
        menuPortalTarget: m ? void 0 : document.body,
        components: {
          Option: this.createDropdownLabel,
          SingleValue: this.createSingleValue,
          DropdownIndicator: this.createDropdownArrow
        },
        isSearchable: !j && o,
        isClearable: !!(j || r),
        loadOptions: s,
        noOptionsMessage: function noOptionsMessage(a) {
          var b = a.inputValue;
          return b ? q || "No results" : p || "Enter text to search";
        }
      }, y)));
    }
  }]), b;
}(_react.Component);

Dropdown.defaultProps = {
  isClearable: !1,
  isSearchable: !1,
  multi: !1,
  labelProps: {},
  placeholder: "Select"
}, Dropdown.Label = _DropdownLabel["default"];
var _default = Dropdown;
exports["default"] = _default;